function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDbtoapi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "4.69 7.7 9.38 4.99 9.38 2.27 2.25 6.38 2.64 6.86 4.26 7.74 4.69 7.7",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38,17.36,2.25,13.25V10.66l7.13,4.12Zm0,1.77L2.25,15v2.6l7.13,4.12Zm0-8.71L4.69,7.7,2.25,6.38v2.5L9.38,13",
    style: {
      fill: "#aecbfa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38,21.73l7-4V15.1l-7,4m0-4.35,7-4h2.08v2.33H16.78l-7.4,4.29Zm0-1.77L16.79,8.7h2.44v1.36l2.51-2.51-2.51-2.5V6.37H16.36l-1.23.72-1.06.61L11.35,9.27l-2,1.15Z",
    style: {
      fill: "#669df6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.38 4.99 12.54 6.82 14.9 5.46 9.38 2.27 9.38 4.99",
    style: {
      fill: "#669df6",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbtoapi);
export default __webpack_public_path__ + "static/media/dbtoapi.26853d11e7bf678b35e6766d183aa588.svg";
export { ForwardRef as ReactComponent };